import { Card, Grid, Typography, CardContent } from '@mui/material';

export default function LoginFormCard({ title = 'Personal Property', children }) {
  return (
    <Grid item>
      <Card sx={{ margin: 'auto', width: '100%' }}>
        <div>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: '1.5rem',
              paddingTop: '2rem',
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
          <CardContent>{children}</CardContent>
        </div>
      </Card>
    </Grid>
  );
}
